import { LocalDate } from '../../../models';

export interface SpecialFreightOverviewModel {
  reference: string;
  carrier: string;
  shipmentCreated: LocalDate;
  truckPlate: string;
}
